import i18n from 'i18next';

export const LOCALE_STORAGE_KEY = 'hiacuity.locale';

export const SUPPORTED_LOCALES = ['en', 'id', 'si', 'ta', 'ru'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const setAppLocale = (locale: SupportedLocale): void => {
  localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  void i18n.changeLanguage(locale);
};
